export default __webpack_public_path__ + "static/media/caret.e540bbd2.svg";